
import { updateCart } from './../../process/pc-slate-tools';
import { QuantitySelector, CLASS_VISIBLE } from './QuantitySelector';

export class CartQuantitySelector extends QuantitySelector {
  constructor(index, container) {
    super(container);

    this.index = index;
  }

  onQuantityChanged(quantity) {
    this.updateQuantity(quantity);
  }

  updateQuantity(qty) {
    updateCart(this.index, qty, this.onCartUpdated());
  }

  onCartUpdated(){
    setTimeout(function(){
      location.reload();
    },500);
  }
}